import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { LitigationFunnelTask } from "../../../api/models/LitigationFunnelMatter";
import { Areas } from "./Areas";

interface Props {
  children?: React.ReactNode;
  index: number;
  value: number;
  tasks: LitigationFunnelTask[]
}

export function TaskTable(props: Props) {
  const { children, value, index, tasks, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && 
            <TableContainer sx={{ height: 400, overflowY: "auto", p: 0, boxShadow: "none", m: 0 }}>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>No</TableCell>
                            <TableCell>Task</TableCell>
                            <TableCell>Due Date</TableCell>
                            <TableCell>Assigned To</TableCell>
                            <TableCell>Funnel</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tasks.map((task, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                            <TableCell component="th" scope="row">
                                {index + 1}
                            </TableCell>
                            <TableCell>{task.task.name}</TableCell>
                            <TableCell>{task.task.due_at ? new Date(task.task.due_at).toLocaleDateString('en-US') : "N/A"}</TableCell>
                            <TableCell>{task.task.assignee.name}</TableCell>
                            <TableCell>{Areas.find(area => area.area === task.area)?.name}</TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        }
    </div>
  );
}
